import { CallPlace } from '../model/http/myActivity.model';
import {
  TabsProfile,
  TabsUtilitiesCalculator,
} from '../model/local/general.model';
import { ICatalogsMissingPro } from '../model/http/catalogs';
import { TabsProfileDoctorView } from '../model/local/general.model';

export const NumberCons = {
  zero: 0,
  one: 1,
  five: 5,
  ten: 10,
  two: 2,
  three: 3,
  screenPhone: 768,
  oneThousand: 1000,
};
export const BooleanCons = {
  true: true,
  false: false,
};
export const FiltersDiseases = [
  {
    name: 'Acné',
    isSelected: false,
  },
  {
    name: 'Alopecia',
    isSelected: false,
  },
  {
    name: 'Anestésicos',
    isSelected: false,
  },
  {
    name: 'Antifúngicos',
    isSelected: false,
  },
  {
    name: 'Antiinflamatorios',
    isSelected: false,
  },
  {
    name: 'Antiirritantes',
    isSelected: false,
  },
  {
    name: 'Antioxidantes',
    isSelected: false,
  },
  {
    name: 'Antipruriginosos/Calmantes',
    isSelected: false,
  },
];
export const LegendsProfileTabs = {
  homeLegends:
    'Estimado cliente, puede hacer sus pedidos a partir de estas tres opciones.',
  taxdatas:
    'Agrega tus datos fiscales y fija uno para que lo uses como predeterminado',
  addresses:
    'Agrega tus direcciones de entrega y fija una para que la usemos como predeterminada',
  shopping: 'Visualiza los artículos que quieres comprar ahora mismo',
  recipeSettings:
    'Configura los datos de tu receta y obtén una vista previa de ellas antes de crearla',
  recipeSettingsAddresses: 'Elije una dirección para colocarla en tu receta',
  needDataTax:
    'Documento de salida emitido con un RFC genérico como venta al mostrador XAXX010101000',
};
export const ContentEmpty = {
  MyFavouritesPage: 'No tienes productos favoritos',
  DetailOrdersListEdit: 'No tienes productos agregados a la lista',
  ShoppingCard: 'Tu carrito se encuentra vacío',
  TaxData: 'No hay Datos Fiscales registrados da click en Agregar nuevos',
  PaymentData: 'No tienes tarjetas registradas',
  DirectionData:
    'No hay Direcciones de entrega registradas da click en Agregar nueva',
  ActiveOrders: 'No tienes pedidos activos',
  DeliveredOrders: 'No tienes pedidos entregados',
  PendingOrders: 'No tienes órdenes pendientes',
  HistoryOrders: 'No tienes pedidos registrados',
  TopOrders: 'No tienes productos Top registrados',
  BioEqual: 'No tienes productos BioEqual  registrados',
  BioElite: 'No tienes productos BioElite registrados',
  Reve: 'No tienes productos Reve registrados',
  Dermazone: 'No hay productos Dermazone para mostrar',
  InvoicesPending: 'No tienes Facturas Pendientes',
  InvoicesInProcess: 'No tienes Facturas en proceso',
  InvoicesInValidation: 'No tienes Facturas en validación',
  InvoicesPaid: 'No tienes Facturas Pagadas',
  UtilitiesInit:
    'Consulta el listado de productos, seleccionando un rango de fechas',
  UtilitiesRange: 'No se encontró información correspondiente ',
  UtilitiesFavorites: 'No se encontró información en favoritos',
  Default: '',
  SearchProductsCatalogs:
    'No se encontró información con los criterios seleccionados',
  MissingProducts: 'No se encontró información en Productos Faltantes',
  NoPromotions: 'Por el momento no tenemos promociones',
  SaveShoppingCard: 'Tu carrito guardado se encuentra vacío, vaya a su carrito de compras para guardar los productos que necesite para comprar después',
  quotation: 'No se encontró información con los criterios seleccionados',
  searchInfo: 'Buscar por itemcode o descripción',
  notFoundResult: 'No se encontraron resultados',
  notFoundInfoQuery: 'No se encontró información correspondiente a la consulta deseada'
};
export const StorageConst = {
  card: 'card',
  cardCode: 'cardCode',
  cardCodeGeneral: 'cardCodeGeneral',
  labels: 'labels',
  constainers: 'containers',
  profile: 'profile',
  objectBuyEdit: 'objectBuyEdit',
  myProfile: 'myProfile',
  doctorSapInfo: 'doctorInfo',
  cardCodeDoctorFromAdvisor: 'cardCodeDoctorFromAdvisor',
  advisorCardCode: 'advisorCardCode',
  oldClasificationCatalog: 'oldClasificationCatalog',
  clasificationCatalog: 'clasificationCatalog',
  advisorClasificationCatalog: 'advisorClasificationCatalog',
  objectClient: 'objectClient',
  userInRole: 'userInRole',
  names: 'prescriptionNames',
  prescription: 'PrescriptionItems',
  counterOrders: 'counterOrders',
  profilePhoto: 'profilePhoto',
  imgGenerateItem: 'imgGenerateItem',
  isValidPrescriptionInfo: 'isValidPrescriptionInfo',
  missingTab: 'missingTab',
  invoiceTab: 'invoiceTab',
  homeInfo: 'homeInfo',
  doctorFilter: 'doctorFilter',
  paymentLimit: 'paymentLimit',
  lastCardSelected: '',
  creditDaysLimit: 'creditDaysLimit',
  totalProducts: 'total-products',
  showedNotificacion: 'showedNotificacion',
  shoppingTab: 'shoppingTab',
  savedPage: 'savedPage',
  myProfileTab: 'profileTab',
  minPiecesQuantity: 'minPiecesCustomLabel',
  generalSearch: 'generalSearch',
  priceList: 'priceList',
  clientType: 'clientType',
  responsibleDoctorId: 'responsibleDoctorId',
  responsibleDoctorAddressNick: 'responsibleDoctorAddressNick',
  pagesTable: 'pagesTable',
};
export const LegendsPaymentMethods = {
  header: 'Agrega tus métodos de pago con tarjeta',
};
export const HttpStatus = {
  ok: 200,
  created: 201,
  redirection: 300,
  badRequest: 400,
  unauthorized: 401,
  forbidden: 403,
  notFound: 404,
  serverError: 500,
  timeOut: 504,
  connectionRefused: 0,
};
export const LineProductCons = {
  no: 'N',
  yes: 'Y',
  noApply: 'NA',
  containerNoApply: 'NO APLICA',
};
export const NeedRecipe = {
  no: 'N',
  yes: 'Y',
};
export const Default = {
  no: 'N',
  yes: 'Y',
};
export const StringConst = {
  empty: '',
};
export const Status = {
  theWay: 'En Camino',
  delivered: 'Entregado',
  sent: 'Enviado',
  sentView: 'Enviado',
  route: 'En ruta',
  notDelivered: 'No Entregado',
};
export const ShippingPackages = {
  dhl: 'DHL',
  fedex: 'FEDEX',
  senda: 'SENDA',
  tdv: 'TDV',
  tres_guerras: 'TRES GUERRAS',
};

export const StatusLegends = {
  theWay: 'Tus productos están en ruta',
  delivered: '<span class="font-omicron-bold color-black">Recibió:</span>',
};
export const ActiveLegends = {
  sapSent: 'SAP enviados',
  productsSent: 'Productos enviados',
  sapPending: 'SAP pendientes',
  productsPending: 'Productos pendientes',
};
export const RoutesCons = {
  home: 'home',
  myProducts: 'my-products',
  historyOrders: 'history-orders',
  myFavourites: 'my-favourites',
  shoppingCar: 'shopping-car',
  myProfile: 'my-profile',
  editBuyOrder: 'edit-buy-order',
  orderResume: 'order-resume',
  deliveryPayment: 'delivery-payment',
  deliveryData: 'delivery-data',
  taxData: 'tax-data',
  pendingOrder: 'pending-order',
  activeOrders: 'active-orders',
  deliveredOrders: 'delivered-orders',
  confirmOrders: 'confirm-order',
  doctorList: 'doctor-list',
  utilities: 'utilities',
  incidents: 'incidents',
  listProduct: 'products-list',
  invoicesPending: 'invoices-pending',
  invoicesPaid: 'invoices-paid',
  averageTicket: 'average-ticket',
  goals: 'goals',
  generateOrder: 'generate-order',
  catalogClassifications: 'catalog-classifications',
  orders: 'orders',
  generateOrderAdvisor: 'order-advisor',
  missingProducts: 'missing-products',
  advisorUtilities: 'utilities-advisor',
  utilsCalculator: 'utils-calculator',
  pay: 'pay',
  createMissingProduct: 'create-missing-product',
  missigList: 'missing-list',
  promotions: 'promotions',
  clientsWallet: 'clients-wallet',
  paymentAndBillings: 'payment-billings',
  tradeCube: 'trade-cube',
  advisorCatalogsClassification: 'advisor-catalog-classification',
  advisorCatalog: 'advisor-catalogs',
  openOrdersReport: 'open-order-reports',
  faqs: 'faqs',
  quotation: 'quotation',
  quotationResume: 'quotation-resume',
  detailReport: 'detail-report',
  recipeConfiguration: 'recipe-configuration',
  paymentFailure: 'failure',
  paymentSuccess: 'success',
  managePromotionCodes: 'manage-promotions',
  createPromotionCode: 'create-promotion',
  editPromotionCode: 'edit-promotion',
  metricsPromotionCode: 'metrics-promotion',
  generalSearch: 'search',
  responsibleDoctorInfo: 'responsible-doctor-info',
  analysisBusiness: 'analysis-my-business',
  potencialBusiness: 'potencial-my-business',
};
export const ParamsConst = {
  currentTab: 'currentTab',
  typeCart: 'typeCart',
  cardCode: 'cardCode',
  orderId: 'orderId',
  orderOption: 'option',
  key: 'key',
  pageIndex: 'page',
  limitPage: 'limit',
  shoppingTab: 'shoppingTab',
  transactionId: 'transactionId',
  paymentType: 'paymentType',
  search: 'itemCode',
  catalog: 'catalog'
};
export const TypeSectionMenu = {
  products: 'pro',
  prodHistory: 'pdh',
  favorites: 'fav',
  profile: 'prf',
};
export enum TypeScreenView {
  mobile,
  tablet,
  web,
  default,
}
export const TitleDialog = {
  changeDeliveryDirection: 'Editar dirección de entrega',
  changeDirection: 'Editar dirección de receta',
  changeTaxData: 'Editar datos fiscales',
  addDeliveryDirection: 'Agregar nueva dirección de entrega',
  addDirection: 'Agregar nueva dirección de receta',
  addAliasDirection: 'Alias de la dirección de entrega',
  addAliasReceiptSettings: 'Alias de la dirección para la receta',
  addTaxData: 'Agregar nuevos datos fiscales',
  botonChangeDirection: 'Agregar nueva',
  botonChangeTaxData: 'Agregar nuevo',
  addPayment: 'Agregar nueva',
  addPaymentCard: 'Agregar nueva tarjeta',
  editPaymentCard: 'Editar método de pago',
};
export const TypeUtility = {
  date: 'date',
  favorites: 'favorites',
};
export const TitlesUtility = {
  date: {
    titleTotal: 'En este periodo tus compras proyectan una utilidad de',
    titlePieces: 'Piezas compradas',
  },
  favorites: {
    titleTotal: 'Utilidad estimada',
    titlePieces: 'Piezas reportadas',
  },
};
export const TitlePage = {
  default: {
    title: '',
    description: '',
  },
  myProducts: {
    title: 'Mis productos Top',
    description:
      'Mantente al tanto de los productos que has comprado durante un año',
  },
  historyOrders: {
    title: 'Mi historial de pedidos',
    description:
      'Consulta tus pedidos realizados dentro de los últimos 6 meses',
  },
  myFavourites: {
    title: 'Mis productos favoritos',
    description: 'Lista de tus productos favoritos',
  },
  editBuyOrder: {
    title: 'Editar y volver a comprar',
    description: 'Puedes editar el pedido #2434543 y vuelve a comprarlo',
  },
  resumeOrder: {
    title: 'Recetas a generar:',
    description: 'Para poder generar tu receta y continuar con el pedido debes completar la siguiente información.',
  },
  deliveryPayment: {
    title: 'Datos de entrega y pago',
    description:
      'Ingresa y/o revisa tus datos de entrega, datos fiscales y métodos de pago',
  },
  pendingOrder: {
    title: 'Mis órdenes pendientes',
    description: 'Se presentan órdenes pendientes',
  },
  activeOrders: {
    title: 'Mis pedidos activos',
    description: 'Se presentan pedidos activos',
  },
  deliveredOrders: {
    title: 'Mis pedidos entregados',
    description:
      'Se presentan pedidos entregados dentro de los últimos 3 meses',
  },
  confirmOrder: {
    title: 'Confirmación de pedido',
    description: '',
  },
  deliveredData: {
    title: 'Direcciones de entrega',
    description: '¿Dónde te gustaría recibir tus productos?',
    descriptionForInstitutional: 'Selecciona tu médico responsable y dirección de entrega para tu pedido'
  },
  shipment: {
    title: 'Envío',
    description: '',
  },
  taxData: {
    title: 'Facturación',
    description: '',
  },

  paymentData: {
    title: 'Métodos de pago',
    description: '',
  },
  paymentDataWithBank: {
    title: 'Tarjeta bancaria',
    description: '',
  },

  asesor: {
    title: 'Clientes',
    description: '',
  },

  otherPaymentData: {
    title: 'Otros métodos de pago',
    description: '',
  },
  incidentProduct: {
    title: 'Buzón de Incidencias',
    description:
      'Reporta los problemas que haya tenido algún producto de tu compra',
  },
  incidentProductAdvisor: {
    title: 'Buzón de Incidencias',
    description:
      'Reporta los problemas que haya tenido algún producto comprado',
  },
  incidentService: {
    title: 'Buzón de Incidencias',
    description: 'Reporta algún problema que hayas tenido con tu servicio',
  },
  bioEqual: {
    title: 'BioEqual',
    description: '',
  },

  bioElite: {
    title: 'BioElite',
    description: '',
  },
  reve: {
    title: 'Rêve',
    description: '',
  },
  dermazone: {
    title: 'Dermazone',
    description: '',
  },
  omigenomics: {
    title: 'Omigenomics',
    description: '',
  },
  utilities: {
    title: 'Mis precios públicos',
    description:
      'Calcula tus -utilidades anuales- ajustando los precios o porcentajes de utilidad según tus preferencias.',
  },
  utilitiesCal: {
    title: 'Calculadora de utilidades',
    description: 'Calcula la utilidad de tus productos favoritos',
  },
  invoicesPending: {
    title: 'Cuentas por pagar',
    description:
      'Su cuenta tiene facturas pendientes. Realice el pago de las más antiguas a través de alguno de sus métodos de pago.',
  },
  invoicesInProcess: {
    title: 'Facturas en proceso',
    description: 'Su factura está en proceso',
  },
  invoicesInValidation: {
    title: 'Facturas en validación',
    description: 'Su factura está en proceso de validación',
  },
  invoicesPaid: {
    title: 'Facturas',
    description: 'Visualiza todas tus facturas que ya han sido pagadas',
  },
  averageTicket: {
    title: 'Ticket promedio',
    description: 'Aquí puedes visualizar los ticket promedio de tus clientes',
  },
  shoppingCard: {
    title: 'Carrito de Compras',
    description: 'Visualiza los artículos que quieres comprar ahora mismo',
  },
  shoppingCardSaved: {
    title: 'Carrito de Compras',
    description: 'Visualiza los artículos que quieres comprar después',
  },
  goals: {
    title: 'Metas',
    description:
      'Consulta las distintas metas que se te han fijado y el progreso que llevas',
  },
  generateOrder: {
    title: 'Generar pedido',
    description: 'Crea un pedido a partir de una categoría',
  },
  missingProducts: {
    title: 'Lista de faltantes',
    description:
      'En esta pantalla puedes visualizar la lista de productos, envases y activos faltantes',
  },
  pendingProducts: {
    title: '',
    description: '',
  },
  packageSent: {
    title: '',
    description: '',
  },
  promotions: {
    title: 'Novedades y Promociones',
    description: 'Aprovecha estas exclusivas novedades y promociones que tenemos para ti.',
  },
  recipeConfig: {
    title: 'Agregar nombre del paciente a recetas',
    description: 'Los nombres del paciente son sugeridos por el sistema y pueden ser modificados',
  },
  recipeTab: {
    title: 'Receta',
    description: 'Configura los datos de tu receta y obtén una vista previa de ellas antes de crearla',
    titleInstitutionalClient: 'Configura los datos de tu receta',
  },
  deliveryDirections: {
    title: 'Direcciones de entrega',
    description: 'Agrega tus direcciones de entrega y fija una para que la usemos como predeterminada',
  },
  taxDirections: {
    title: 'Datos fiscales',
    description: 'Agrega tus datos fiscales y fija uno para que lo uses como predeterminado',
  },
  paymentMethods: {
    title: 'Métodos de pago',
    description: 'Agrega tus métodos de pago con tarjeta',
  },
  accountConfiguration: {
    title: 'Configuración de cuenta',
    description: 'Una contraseña segura evitará el acceso no autorizado a tu cuenta'
  },
  doctorProfile: {
    title: 'Perfil',
    description: 'Ingresa la información personal y la de tu clínica/consultorio',
  },
  generatePromotion: {
    title: 'Código promocional',
    description: 'Configure el código y los usuarios que lo recibirán'
  }
};
export const MyProductsPage = {
  displayColumns: [
    'itemCode',
    'description',
    'piecesQuantity',
    'costPerPiece',
    'container',
    'label',
    'favorite',
    'actions',
  ],
};
export const PendingInvoicesTable = {
  displayColumns: [
    'spinner',
    'invoiceId',
    'totalProducts',
    'totalPieces',
    'status',
    'amountTotal',
    'amountRemaining',
    'download-invoice',
  ],
};

export const MissingProductsListTable = {
  displayColumns: ['itemCode', 'description'],
};

export const ProcessInvoicesTable = {
  displayColumns: [
    'payDate',
    'wayToPay',
    'numberInvoices',
    'amountTotal',
    'status',
    'invoice',
    'actions',
  ],
};

export const PendingInvoicesStatus = {
  validation: 'En validación',
  pending: 'Pendiente por pagar',
  pendingToPay: 'Pago en espera',
  paymentInProcess: 'En proceso de pago',
};
export const HistoryOrdersPage = {
  displayColumns: [
    'pedidoIdAndData',
    'totalProducts',
    'totalPieces',
    'recipeInvoice',
    'AmountTotal',
    'actions',
  ],
};
export const ResponsibleDoctorsPage = {
  displayColumns: [
    'name',
    'specialty',
    'licenseNumber',
    'institution',
    'action'
  ],
  displayColumnsAdvisor: [
    'name',
    'specialty',
    'licenseNumber',
    'institution',
  ],
};
export const UtilitiesProductsTable = {
  displayedColumns: [
    'product',
    'description',
    'purchasedPieces',
    'costPerPiece',
    'publicPrice',
    'marginPiece',
    'pieceUtility',
  ]
};
export const MyFavouritesPage = {
  displayColumns: [
    'pedidoId',
    'description',
    'costPerPiece',
    'container',
    'label',
    'favorite',
    'actions',
  ],
};
export const MyPendingOrders = {
  displayColumns: [
    'dateOrder',
    'totalProducts',
    'piecesQuantity',
    'status',
    'actions',
    'delete-action',
  ],
};
export const InvoicesPaidData = {
  displayColumns: [
    'invoiceId',
    'totalProducts',
    'totalPieces',
    'paymentMethod',
    'paymentDate',
    'amountTotal',
    'download-invoice',
  ],
};
export const ClientsWalletData = {
  displayColumns: [
    'cardCode',
    'clientName',
    'license',
    'email',
    'phone',
    'address',
    'seller',
    'clientGroup',
    'birthDate',
    'createDate',
    'addressType',
  ]
};
export const PaymentAndBillingData = {
  displayColumns: [
    'paymentNumber',
    'paymentDate',
    'cardCode',
    'name',
    'invoiceDate',
    'invoiceNumber',
    'referenceNumber',
    'documentTotal',
    'appliedAmount',
    'tax',
    'paymentNotDiscount',
    'seller',
  ]
};

export const TradeCubeData = {
  displayColumns: [
    'cardCode',
    'clientName',
    'clientGroup',
    'itemCode',
    'description',
    'productGroup',
    'quantity',
    'container',
    'label',
    'recipe',
    'invoiceDate',
    'invoiceId',
    'comments',
    'totalLine',
    'totalDoc',
    'sellerNumber',
    'seller',
  ]
};

export const OpenOrderReportData = {
  displayColumns: [
    'transactionId',
    'status',
    'transactionDate',
    'cardCode',
    'clientName',
    'totalAmount',
    'paymentDate',
    'sapDetail',
    'shopDetail'
  ]
};
export const InvoicesPendingData = {
  displayColumns: ['invoiceId', 'totalProducts', 'totalPieces', 'amountTotal'],
};
export const PATTERNS = {
  rfc: /^([A-ZÑ\x26 | a-zñ\x26 ]{3,4}([0-9]{2})(0[1-9]|1[0-2])(0[1-9]|1[0-9]|2[0-9]|3[0-1]))([A-Z\d | a-z\d ]{3})$/,
  onlyNumbers: /^[0-9]+$/,
  email:
    /^(([^<>()[\]\\.,;:\s@\']+(\.[^<>()[\]\\.,;:\s@\']+)*)|(\'.+\'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  urls: /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/,
  onlyNames: /^[\p{L}]+(?:\s[\p{L}]+)*$/u,
  numberDaysWeek: /^[1-7]+$/,
  naturalNumbers: /^0*[1-9][0-9]*$/,
  percentage: /^\d+(\.\d{1,2})?$/,
};
export const enum MessageType {
  none,
  myProducts,
  home,
  myProfile,
  error,
  sendToShoppingCart,
  general,
  delete,
  default,
  licence,
  orderResume,
  defaultAddress,
  myFavorites,
  deleteClinicInfo,
  noSafeInfoInForm,
  validateLabel,
  exitApp,
  insufficientCredit,
}
export const MessageTypeCompare = {
  none: 0,
  myProducts: 1,
  home: 2,
  myProfile: 3,
  error: 4,
  sendToShoppingCart: 5,
  general: 6,
  delete: 7,
  default: 8,
  licence: 9,
  orderResume: 10,
  defaultAddress: 11,
  myFavorites: 12,
  deleteClinicInfo: 13,
  noSafeInfoInForm: 14,
  validateLabel: 15,
  exitApp: 16,
  insufficientCredit: 17,
};
export const NamePage = {
  home: 'Inicio',
  history: 'Mi historial de pedidos',
  top: 'Mis productos Top',
  favorite: 'Mis productos favoritos',
  activeOrder: 'Mis pedidos activos',
  pendingOrder: 'Mis órdenes pendientes',
  deliveyOrder: 'Mis pedidos entregados',
  perfil: 'Mi Perfil',
  ShoppingCar: 'Carrito de compras',
  customer: 'Clientes',
  bioEqual: 'BioEqual',
  bioElite: 'BioElite',
  Reve: 'Reve',
  Dermazone: 'Dermazone',
  invoicesPending: 'Cuentas por pagar',
  invoicesPaid: 'Facturas',
  averageTicket: 'Ticket promedio',
  missingList: 'Lista de faltantes',
  goals: 'Metas',
  myUtilities: 'Mis precios públicos',
  utilitiesCalculate: 'Calculadora de utilidades',
  incidentMailbox: 'Buzón de Incidencias',
  promotions: 'Promociones',
  catalogs: 'Catálogos',
  clientsWallet: 'Cartera de Clientes',
  paymentsAndBillings: 'Pagos y Facturas',
  tradeCube: 'Cubo Comercial',
  openOrderReport: 'Seguimiento de partidas abiertas',
  quotation: 'Cotización',
  omigenomics: 'Omigenomics',
  faqs: 'FAQs',
  managePromotionsCode: 'Administrar código promocional',
  createPromotionsCode: 'Crear código promocional',
  editPromotion: 'Editar código promocional'
};
export enum IVAMessages {
  containstIVA = 'El precio incluye IVA',
  noContainsIVA = 'El precio no incluye IVA',
}
export const Welcome = 'Bienvenido,';
export const InitialsDr = 'Dr. ';

export const MaxAmountPaymentMethod = '*Monto máximo de ';

export const LegendHeaderAdvisers = {
  manyAdvisers: 'Tus asesores son',
  oneAdviser: 'Tu asesor es',
};
export enum WhoRequestAccordionMenu {
  accordionMyProfile = 1,
  accordionGenerate = 2,
  accordionMyProducts = 3,
  accordionHome = 4,
  notAccordion = 5,
  accordionOrders = 6,
  accordionListDoctor = 7,
  accordionCatalog = 8,
  accordionInvoice = 9,
  accordionUtilities = 10,
  accordionSales = 11,
  accordionMissingProducts,
  accountState,
}
export const Roles = {
  doctor: '1',
  advisor: '0',
};

export const FavoriteAddDelete = {
  add: 'add',
  delete: 'delete',
};
export const TypeListProduct = {
  bioEqual: 'Bioequal',
  bioElite: 'Bioelite',
  Reve: 'REVE',
  Dermazone: 'Dermazone',
  MagistralDermocosmeticos: 'Magistral Dermocosmeticos',
  MagistralMedicamentos: 'Magistral Medicamentos',
  default: '',
  Omigenomics: 'Omigenomics'
};

export enum TypeCatalogs {
  bioEqual = 'Bioequal',
  bioElite = 'Bioelite',
  Reve = 'REVE',
  Dermazone = 'Dermazone',
  MagistralDermocosmeticos = 'Magistral Dermocosmeticos',
  MagistralMedicamentos = 'Magistral Medicamentos',
  default = '',
  Omigenomics = 'Omigenomics'
}

export const TypeCatalogsCompare = {
  bioEqual: 'Bioequal',
  bioElite: 'Bioelite',
  Reve: 'REVE',
  Dermazone: 'Dermazone',
  MagistralDermocosmeticos: 'Magistral Dermocosmeticos',
  MagistralMedicamentos: 'Magistral Medicamentos',
  default: '',
  Omigenomics: 'Omigenomics'
};
export const ROUTE_BY_TYPE_PRODUCT: { [key: string]: string } = {
  bioequal: `${RoutesCons.listProduct}/${TypeListProduct.bioEqual}/`,
  bioelite: `${RoutesCons.listProduct}/${TypeListProduct.bioElite}/`,
  reve: `${RoutesCons.listProduct}/${TypeListProduct.Reve}/`,
  dermazone: `${RoutesCons.listProduct}/${TypeListProduct.Dermazone}/`,
  '': '',
  omigenomics: `${RoutesCons.listProduct}/${TypeListProduct.Omigenomics}/`,
};

export const TypeAutoComplete = {
  ailment: 'Ailment',
  speciality: 'Speciality',
  active: 'Active',
  presentation: 'Presentation',
  generalSearch: 'generalSearch',
  code: 'code',
  subLines: 'Subline',
};
export const NameCatalogSegmentationStatic = {
  all: 'TODOS',
  dermazoneBioElite: 'Dermatologia & BioElite',
  BioEqualBioElite: 'BioEqual & BioElite',
  allOmi: 'TODOS OMI',
};

export const LimitGlobal = 10;
export const OffsetAutoComplete = 5;
export enum Operation {
  sum,
  subtraction,
}
export class ShoppingCounter {
  pieces?: number;
  operationType?: Operation;
}
export const DownloadInvoiceTooltip = {
  xml: 'Descargar xml',
  pdf: 'Descargar pdf',
};
export const ExcludeDescriptionCatalog = {
  noApplyLabel: 'NA',
  noApplyContainer: 'NO APLICA',
};
export const TypesImages = ['png', 'jpg', 'jpeg'];
export const DefaultLicence = 'c1';
export const TypeSignatureImage = {
  gallery: 'gallery',
  hand: 'hand',
};
export const Base64Prefix = 'data:image/png;base64,';

export enum typeImagesToLoad {
  logo = 'Logo',
  signature = 'Signature'
}

export enum signatureType {
  image = 'image',
  hand = 'hand',
}

export enum Actions {
  insert = 'i',
  update = 'u',
  delete = 'd',
  default = 'USE',
  none = '',
}

export enum ActionsClinicInfo {
  insert = 'I',
  update = 'U',
  delete = 'D',
  none = '',
}

export const TooltipText = {
  shoppingCar: 'Quitar del carrito',
  shoppingCarSaved: 'Quitar del carrito guardado',
  deliveryAddress: 'Quitar dirección de entrega',
  taxData: 'Quitar datos fiscales',
  detailOrderEdit: 'Quitar de la lista',
  profileDirection: 'Quitar dirección',
};

export const DefaultButtonTitle = {
  addressDeliveryDefault: 'Predeterminada',
  addressDelivery: 'Usar como predeterminada',
  taxDataDefault: 'Predeterminado',
  taxData: 'Usar como predeterminado',
  receiptSettings: 'Usar esta dirección',
  packagesSent: 'Productos enviados del pedido: #',
  pendingProducts: 'Productos pendientes por enviar del pedido: #',
  detailOrder: 'Detalle del pedido: #',
};

export const EstatusOrder = {
  RegisterOrder: 1,
  ConfirmedAndProcess: 2,
  OnWay: 3,
  delivered: 4,
};
export const RolesString = {
  doctor: 'doctor',
  advisor: 'advisor',
  reporter: 'reporter',
  adminPromo: 'coupons-admin'
};

export const RoutePermissions = {
  menu: [
    {
      id: 'profile',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'home',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'generate_orders',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'my_orders',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'doctor_list',
      roles: [RolesString.advisor],
      isShow: false,
    },
    {
      id: 'incidents',
      roles: [RolesString.doctor, RolesString.advisor],
      isShow: false,
    },
    {
      id: 'invoicedPending',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'utilities',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'average-ticket',
      roles: [RolesString.advisor],
      isShow: false,
    },
    {
      id: 'missing-products',
      roles: ['reporter', RolesString.advisor],
      isShow: false,
    },
    {
      id: 'promotions',
      roles: [RolesString.doctor],
      isShow: false,
    },
    {
      id: 'sap_reports',
      roles: [RolesString.advisor],
      isShow: false
    },
    {
      id: 'advisor_catalogs',
      roles: [RolesString.advisor],
      isShow: false
    },
    {
      id: 'faqs',
      roles: [RolesString.advisor, RolesString.doctor],
      isShow: false
    },
    {
      id: 'quotation',
      roles: [],
      isShow: false
    },
    {
      id: 'promotions',
      roles: [RolesString.adminPromo]
    },
    {
      id: 'webinar',
      roles: [RolesString.doctor]
    }
  ],
};

export const PaymentMethods = {
  spei: 'spei',
  paynet: 'paynet',
  card: 'card',
};

export const IncidentsLegend = {
  productIncident:
    'Agrega por lo menos una foto como evidencia de como recibiste tu producto.',
  productIncidentAdvisor:
    'Agrega por lo menos una foto como evidencia del producto recibido.',
  serviceIncident:
    'Agrega por lo menos una foto como evidencia del incidente con un servicio.',
};

export const ProductIncidentOptionalImage = ['Producto faltante', 'Otro'];

export const DisplayDialogIncidentTypes = ['PRODUCTO FALTANTE', 'PRODUCTO DERRAMADO'];

export const IncidenstValidators = {
  product: {
    images: [
      { option: 'Falla en el envase', required: false },
      { option: 'Producto mal solicitado', required: false },
      { option: 'Producto faltante', required: false },
      { option: 'Producto derramado', required: true },
      { option: 'Producto con mala estabilidad', required: true },
      { option: 'Otro', required: false },
    ],
    invoiceNumber: [
      { option: 'Falla en el envase', required: true },
      { option: 'Producto mal solicitado', required: true },
      { option: 'Producto faltante', required: true },
      { option: 'Producto derramado', required: true },
      { option: 'Producto con mala estabilidad', required: true },
      { option: 'Otro', required: true },
    ],
    showInvoiceInput: [
      { option: 'Falla en el envase', show: true },
      { option: 'Producto mal solicitado', show: true },
      { option: 'Producto faltante', show: true },
      { option: 'Producto derramado', show: true },
      { option: 'Producto con mala estabilidad', show: true },
      { option: 'Otro', show: true },
    ],
    showAdvisorList: [
      { option: 'Falla en el envase', show: false },
      { option: 'Producto mal solicitado', show: false },
      { option: 'Producto faltante', show: false },
      { option: 'Producto derramado', show: false },
      { option: 'Producto con mala estabilidad', show: false },
      { option: 'Otro', show: false },
    ]
  },
  service: {
    images: [
      { option: 'Paquetería', required: false },
      { option: 'Asesor comercial', required: false },
      { option: 'Otro', required: false },
    ],
    invoiceNumber: [
      { option: 'Paquetería', required: true },
      { option: 'Asesor comercial', required: false },
      { option: 'Otro', required: false },
    ],
    showInvoiceInput: [
      { option: 'Paquetería', show: true },
      { option: 'Asesor comercial', show: false },
      { option: 'Otro', show: false },
    ],
    showAdvisorList: [
      { option: 'Paquetería', show: false },
      { option: 'Asesor comercial', show: true },
      { option: 'Otro', show: false },
    ]
  },
};

export const InvoiceNumberControl = 'invoiceNumber';
export const Dermazone = 'DERMAZONE';
export const PaynetMessageErrors = {
  userExists: {
    spanish: 'El correo ya se encuentra en uso',
    english: 'User exists with same email',
  },
};

export const DoctorEmailMissingMessage =
  'Este doctor no tiene registrado un correo electrónico en SAP. Registra uno para poderle enviar la invitación de acceso por este medio.';

export const AddClinicInformationTitle = {
  add: 'Agregar nueva clínica / consultorio',
  update: 'Editar información de clínica / consultorio',
};

export const ListSpecialty = [
  'Dermatología',
  'Ginecología',
  'Control de peso',
  'Cardiología',
  'Pediatría',
  'Geriatría',
];
export const ListPresentation = [
  '7.5ml',
  '15ml',
  '30ml',
  '60ml',
  '120ml',
  '240ml',
  '480ml',
  '960ml',
];

export const GoalTypes = {
  billing: 'Facturacion',
  payment: 'Cobranza',
};

export const ClientsOptions = {
  new: 'new',
  active: 'active',
};

export const OrderOptions = {
  active: 'active',
  pending: 'pending',
  delivered: 'delivered',
};

export const DoctorProfileOptions = {
  profile: 'profile',
  configAccount: 'configAccount',
  configRecipe: 'configRecipe',
  payMethods: 'payMethods',
  delivery: 'delivery',
  taxData: 'taxData',
};
export const EstatusTypeCard = {
  doctorShopping: 1,
  doctorEdit: 2,
  advisorShopping: 3,
  advisorEdit: 4,
  savedCart: 5,
  withoutTypeCard: 0,
};
export const StatusPendingOrder = {
  authorize: 'Autorizar',
};

export const enum ImageType {
  container = 'Envase',
  product = 'Product',
}

export const ImageTypeCompare = {
  container: 'Envase',
  product: 'Product',
};

export const FINISH_ORDER = 'Terminar orden';
export const PAY_FINISH_ORDER = 'Finalizar';
export const PAY_AND_FINISH_ORDER = 'Pagar y finalizar';
export const SIGNATURE_TEXT = ', fírmala y revisa tu pedido';

export const OrderStatusString = {
  received: 'Pedido recibido',
  process: 'Estamos elaborando tu pedido',
  incomming: 'Algunos de tus productos han sido enviados',
};
export const TitleStatus = {
  received: 'Hemos recibido tu pedido',
  process: 'Confirmado y en proceso',
  incomming: 'En ruta',
  delivered: 'Entregado',
  send: 'Enviado',
};



export const CatalogsString = {
  catalog: 'Catálogo',
  container: 'Envase',
};
export const TERMS_URL =
  'https://omicronsaprod.blob.core.windows.net/resources/TermsConditions.pdf';

export const PRIVACY_POLICIES_URL =
  'https://omicronsaprod.blob.core.windows.net/resources/PrivacyNotice.pdf';

export const ParamsSearchSubmitCatalog = {
  paramsSearchSubmitBioEqual: 'Speciality, Ailment, Active',
  paramsSearchBioElite: 'Speciality, Active, Presentation',
  paramsSearchReve: 'Subline',
  paramsSearchDermazone: 'Ailment, Active, Presentation',
};

export const PaymentTypes = {
  paynet: 'store',
  spei: 'bank_account',
};
export const NetPrices = 'Precios netos';
export const NetPricesAndProfit = 'Precios netos y utilidad anual';
export const helpUtilities = 'Utilidad calculada en base a las ventas anuales y precios configurados';

export const FilterButtonText = {
  show: 'Mostrar filtros',
  hide: 'Ocultar filtros',
};

export const LegendByAuthorizeOrder = {
  legendOkDeliveryAndTaxData:
    '*Al autorizar estás aceptando el método de pago, dirección de entrega, datos fiscales y productos solicitados, no hay cambios ni modificaciones una vez procesado tu pago.',
  legendOkRecipe:
    '**Si los productos requieren receta también se está autorizando la generación de la receta digital.',
  legendAdvisor:
    'El pedido entrará a producción hasta ser autorizado por el médico.',
  legendConfirmPayment: '*Al Pagar y finalizar estás aceptando el método de pago, dirección de entrega, datos fiscales y productos solicitados.',
  legendConfirmPaypal: '*Al pagar con PayPal estás aceptando el método de pago, dirección de entrega, datos fiscales y productos solicitados.',
  legendConfirmNoCard: '*Al finalizar estás aceptando el método de pago, dirección de entrega, datos fiscales y productos solicitados.',
  legendConfirmBBVA: '*Al pagar con BBVA estás aceptando el método de pago, dirección de entrega, datos fiscales y productos solicitados.',
};
export const legendByPricesUpdated = {
  pricesUpdated: '*Precios actualizados al día de hoy',
};

export const legendBySubjectPrices = {
  subjetcPricesCard: '*Precios sujetos a cambio al cambiar el método de pago',
  subjetcPricesOtherPaymentMethods:
    '*Precios sujetos a cambio al vencer el código o al cambiar método de pago',
};

export const DontShowDetailButtonList = [
  CallPlace.pendingOrders,
  CallPlace.pendingOrdersDialog,
];


export enum TabsNames {
  profile = 'Perfil',
  accountSettings = 'Configuración de cuenta',
  recipeSettings = 'Configuración de receta',
  paymentMethods = 'Métodos de pago',
  deliveryAddresses = 'Direcciones de entrega',
  taxData = 'Datos fiscales',
  responsibleDoctors = 'Médicos responsables'
}

export const Tabs = [
  { name: TabsNames.profile, tab: TabsProfile.profile },
  { name: TabsNames.accountSettings, tab: TabsProfile.accountSettings },
  { name: TabsNames.recipeSettings, tab: TabsProfile.recipeSettings },
  { name: TabsNames.paymentMethods, tab: TabsProfile.paymentMethods },
  { name: TabsNames.deliveryAddresses, tab: TabsProfile.deliveryAddresses },
  { name: TabsNames.taxData, tab: TabsProfile.taxData },
  { name: TabsNames.responsibleDoctors, tab: TabsProfile.responsibleDoctors },
];

export interface ITabs {
  title: string;
  index: number;
}

export const ListTabsOptionUtilitiesCalculator = [
  {
    title: 'Mis precios públicos',
    tab: TabsUtilitiesCalculator.utilities,
  },
  {
    title: 'Análisis actual de mi negocio',
    tab: TabsUtilitiesCalculator.analysisBusiness,
  },
  {
    title: 'Potencial de mi negocio',
    tab: TabsUtilitiesCalculator.potencialBusiness,
  },
  {
    title: 'Calculadora de utilidades',
    tab: TabsUtilitiesCalculator.utilitiesCalculator,
  },
];

export const InvoicesDetailHeaderTitle = {
  process:
    'Tu pago está pendiente. Procesaremos tu factura una vez que se haya realizado.',
  validation:
    'Tu pago se está validando. Procesaremos tu factura tan pronto como se acredite.',
};
export const TABS_MISSING_PRODUCTS_CONFIG: ICatalogsMissingPro[] = [
  { value: 'Materia Prima' },
  { value: 'Envase' },
  { value: 'Producto Terminado' },
];

export const LegendsAutoComplete = {
  rawMaterial: 'Materia prima',
  activePrinciples: 'Principio activo',
};

export const MissingProductsType = {
  activePrinciple: 'Materia Prima',
  container: 'Envase',
  product: 'Producto Terminado',
};

export const PaymentChartConfig = {
  backgroundColors: ['#1875F0', '#B3D2FA'],
  labels: ['Actual', 'Meta'],
};

export enum PaymentTypeInfo {
  spei = 'bank_transfer_payment',
  oxxo = 'cash_payment',
  card = 'card_payment',
  credit = 'credit_payment',
  paypal = 'paypal',
  bbvaMulti = 'bbvamulti',
  default = '',
}
export const PaymentTypeInfoCompare = {
  spei: 'bank_transfer_payment',
  oxxo: 'cash_payment',
  card: 'card_payment',
  credit: 'credit_payment',
  paypal: 'paypal',
  bbvaMulti: 'bbvamulti',
  default: '',
};
export enum TypeBBVAPayments {
  digitalCheck = 'CIE',
  branchPayment = 'SUC',
  practiCaja = 'PCB',
  interbankTransfer = 'CIE_INTER',
  visaMastercard = 'TDX',
  clabe = 'CLABE',
  amex = 'AMEX',
  default = ''
}
export enum TypeBBVAReturn {
  order = 'order',
  invoice = 'invoice',
  changeinvoiceorder = 'changeinvoiceorder',
  changepayorder = 'changepayorder',
  default = ''
}
export enum PaymentCardNames {
  mastercard = 'mastercard',
  visa = 'visa',
  carnet = 'carnet',
  american_express = 'american_express',
  credit = 'credit_payment',
  default = '',
}

export const GENERIC_RFC = 'XAXX010101000';

export const CURRENCY = 'MXN';

export const DermazoneList = [
  'MAGISTRAL DERMOCOS',
  'MAGISTRAL MEDICAMENT',
  'DERMAZONE'
];

export const RecipesWithCustomConfig = [
  'BIOELITE',
  'BIOEQUAL',
];

export const CallBackEmptyConst = () => { };

export const OmicronLabDirection = [
  'Entrega en las instalaciones de OmicronLab',
  'Dirección',
  'OmicronLab S.A de C.V.',
  'Del Refugio 4120, Alfareros, 64753',
  'Monterrey, N.L.',
  'Tel.: 8115222896'
];

export const TaxDirection = [
  'RFC genérico como venta al mostrador XAXX010101000'
];

export const enum TypeClients {
  general = 'general',
  institucional = 'institucional',
  clinica = 'clinica',
}

export const promoCodeNoLabelOptions: { [key: string]: string } = {
  NA: 'PRODUCTOS SIN ETIQUETA',
  TODAS: 'TODAS',
};

export enum typeViewCatalogs {
  sugested = 1,
  specialties = 2,
  sublines = 3,
  ailments = 4,
}

export const FiltersSearchSubmitCatalog = {
  paramsSearchSubmitBioEqual: [
    {
      title: 'Especialidad',
      filter: 'Speciality'
    },
    {
      title: 'Indicación médica',
      filter: 'Indication'
    },
    {
      title: 'Principio activo',
      filter: 'Active'
    },
  ],
  paramsSearchBioElite: [
    {
      title: 'Especialidad',
      filter: 'Speciality'
    },
    {
      title: 'Principio activo',
      filter: 'Active'
    },
    {
      title: 'Presentación',
      filter: 'Presentation'
    },
  ],
  paramsSearchReve: [
    {
      title: 'Sublinea',
      filter: 'Subline'
    },
  ],
  paramsSearchDermazone: [
    {
      title: 'Padecimiento',
      filter: 'Ailment'
    },
    {
      title: 'Principio activo',
      filter: 'Active'
    },
    {
      title: 'Presentación',
      filter: 'Presentation'
    },
  ],
};

export enum typeCatalogFilters {
  specialty = 'Speciality',
  ailment = 'Ailment',
  active = 'Active',
  presentation = 'Presentation',
  subline = 'Subline',
  indication = 'Indication',
}

export const MinShippingPromoCodeAmount = 0.01;

export const invoiceType = {
  completa: 'Completa',
  parcial: 'Parcial'
};

export const deliveryType = {
  completa: 'Enviar todo junto',
  parcial: 'Recibir lo disponible primero'
};

